import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/thumb.module.scss';

import thumb from '../../../img/thumbup.png';

const propTypes = {
    valid: PropTypes.oneOf([true, false, null]),
    className: PropTypes.string,
};

const defaultProps = {
    valid: null,
    className: null,
};

function ThumbIcon({ valid, className }) {
    return (
        <img
            className={classNames([
                styles.container,
                { [styles.invalid]: valid === false, [className]: className !== null },
            ])}
            src={thumb}
            alt="Thumb"
        />
    );
}

ThumbIcon.propTypes = propTypes;
ThumbIcon.defaultProps = defaultProps;

export default ThumbIcon;
